module.exports = __webpack_public_path__ + "static/fast-dialog-f949916b8762c59f5b01ef4aa74bfeb3.png";